// src/store/slices/createQuickAccessSlice.js
// Per-username pinned dashboard categories. Kept in its own top-level slice
// (not inside `auth`) so it survives logOut()/RESET_APP, which clear auth.

import { message } from "antd";

export const QUICK_ACCESS_MAX = 12;

export const createQuickAccessSlice = ((set, get) => ({
    quickAccess: {
        byUser: {}, // { [username]: string[] categoryIds }
    },

    isQuickAccess: (username, categoryId) => {
        if (!username) return false;
        const ids = get().quickAccess.byUser[username] || [];
        return ids.includes(categoryId);
    },

    toggleQuickAccess: (username, categoryId) => {
        if (!username) return;
        const current = get().quickAccess.byUser[username] || [];
        const isPinned = current.includes(categoryId);

        if (!isPinned && current.length >= QUICK_ACCESS_MAX) {
            message.warning(`حداکثر ${QUICK_ACCESS_MAX} آیتم را می‌توانید به دسترسی سریع اضافه کنید`);
            return;
        }

        set(state => {
            const list = state.quickAccess.byUser[username] || [];
            const next = list.includes(categoryId)
                ? list.filter(id => id !== categoryId)
                : [...list, categoryId];
            return {
                quickAccess: {
                    ...state.quickAccess,
                    byUser: {
                        ...state.quickAccess.byUser,
                        [username]: next,
                    },
                },
            };
        });
    },
}))
